import React from 'react';

import { css, cx } from '@emotion/css';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { Button } from '@/uiKit/atoms/Button.tsx';
import { CardFooter } from '@/uiKit/atoms/card/CardFooter.tsx';
import { PRESCRIPTION_INFO_FORM_ID } from '@/uiKit/organisms/PatientCreationAndRenewal/PrescriptionInfo/PrescriptionInfoForm.tsx';

export type PrescriptionSignActionsProps = {
  submitTitle: string;
  onSubmit: () => void;
  onBack?: () => void;
  className?: string;
};

export const PrescriptionSignActions: React.FC<
  PrescriptionSignActionsProps
> = ({ submitTitle, onSubmit, onBack, className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  return (
    <CardFooter className={cx(styles.container, className)}>
      <Button
        variant="outlined"
        id="patient-info-cancel"
        onClick={() => onBack && onBack()}
      >
        {t('button.back')}
      </Button>
      <Button
        form={PRESCRIPTION_INFO_FORM_ID}
        id="patient-info-next"
        onClick={onSubmit}
        variant="contained"
      >
        {submitTitle}
      </Button>
    </CardFooter>
  );
};

const makeStyles = () => ({
  container: css({}),
});
